import fetchUserData from "@/middleware/fetchUserData";
import persistWebview from "@/middleware/persistWebview";

const mainPageBreadCrumb = [{ name: "layouts.main_page", link: "Home" }];
export default [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "layout" */ "@/layouts/User.vue"),
    meta: {
      middlewares: [fetchUserData, persistWebview],
    },
    children: [
      {
        path: "checkout/after-payment/:id",
        name: "CheckoutAfterPayment",
        meta: {
          breadcrumb: [...mainPageBreadCrumb, { name: "layouts.cart" }],
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "checkout" */ "@/views/Checkout/AfterPayment.vue"
          ),
      },
      {
        path: "cart/:id?",
        name: "Cart",
        meta: {
          breadcrumb: [...mainPageBreadCrumb, { name: "layouts.cart" }],
        },
        props: true,
        component: () =>
          import(/* webpackChunkName: "checkout" */ "@/views/Checkout.vue"),
      },
      {
        path: "quick-call/:uid",
        name: "QuickCall",
        component: () =>
          import(
            /* webpackChunkName: "video" */ "@/views/User/Call/QuickCall.vue"
          ),
      },

      {
        path: "call/:uid",
        name: "Account.Call",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "@/views/User/Account/Call.vue"
          ),
      },
    ],
  },
  {
    path: "/home",
    name: "Home",
    beforeEnter: () => {
      window.location.href = process.env.VUE_APP_LANDING_PAGE;
    },
  },
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "user-layout" */ "@/layouts/User.vue"),
    children: [
      {
        path: "error",
        name: "Error",
        meta: {
          breadcrumb: [...mainPageBreadCrumb, { name: "not_found_page.error" }],
        },
        component: () =>
          import(/* webpackChunkName: "error" */ "@/views/Error.vue"),
      },
      {
        path: "/error/:code",
        name: "ErrorCode",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "errors-codes" */ "@/views/Errors/ErrorCode.vue"
          ),
      },
      {
        path: "/:catchAll(.*)",
        component: () =>
          import(/* webpackChunkName: "not-found" */ "@/views/NotFound.vue"),
      },
    ],
  },
];
